





















import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { ErrorManager } from '@/models/error';

export default Vue.extend({
  name: 'HRDepartmentPicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: [Number, Object],

    externalErrorMessage: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },

  data() {
    return {
      lazyValue: this.value,
      errorMessage: '',
      loading: false
    };
  },

  watch: {
    value: {
      handler(val: any, prevVal: any) {
        this.lazyValue = val;
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters({
      hrDepartments: 'hrDepartment/getHrDepartments'
    }),

    internalValue: {
      get(): any {
        return this.lazyValue;
      },
      set(val: any) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    errorMessageList(): string[] {
      let errorList: string[] = [];
      if (this.externalErrorMessage) {
        errorList = this.externalErrorMessage;
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  mounted() {
    this.fetchHRDepartments();
  },

  methods: {
    ...mapActions({
      fetchHrDepartments: 'hrDepartment/fetchHrDepartments'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.$emit('clearAllErrors');
    },

    fetchHRDepartments() {
      this.clearAllErrors();
      this.loading = true;
      this.fetchHrDepartments()

        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
